module.exports = __webpack_public_path__ + "static/02-e2435a25a5d01879725ac7dc1d3e387f.jpg";